// src/components/LiveDeviceValue.jsx
// Valore di un dispositivo che cambia di continuo (velocità, battito), letto
// dall'archivio in memoria delle pagine di setup e ridisegnato da solo una
// volta al secondo: la pagina intorno non si ridisegna a ogni pacchetto GPS.
import { useEffect, useState } from 'react';

export default function LiveDeviceValue({ store, mac, field, format = (v) => v }) {
  const [v, setV] = useState(() => store.current[mac]?.[field]);
  useEffect(() => {
    const t = setInterval(() => {
      const x = store.current[mac]?.[field];
      setV(prev => (prev === x ? prev : x));
    }, 1000);
    return () => clearInterval(t);
  }, [store, mac, field]);
  return format(v);
}
